import type { ReactNode } from 'react';

interface CardProps {
  children: ReactNode;
  className?: string;
}

export const Card = ({ children, className = '' }: CardProps) => {
  return (
    <div
      className={`z-10 rounded-md bg-neutralBG p-4 shadow-md dark:bg-neutralBG-dark ${className}`}
      style={{ height: 'min-content' }}
    >
      {children}
    </div>
  );
};
